module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client_three-5196fa8c6c53ba31d8144cf964faa489.png";